import React, { useState,useContext, useEffect } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import JisButton from '../../components/controls/jisButton';
import JisCheckbox from '../../components/controls/jisCheckbox';
import { ShareContext } from '../../context/ShareContext'
import * as Constants from '../../constants';
import * as Services from '../../services';
import JisTabButton from '../../components/controls/jisTabButton';
import BackLoader from '../../components/backloader';
import JisDialog from '../../components/dialog';
import JisDialogForm from '../../components/formdialog';

function JudgementSettings() {
    const {  activePage, token, setIsExpired,setAlert,frequentData} = useContext(ShareContext);
     const [page, setPage] = useState(null);
     const [tab, setTab] =useState('ordertype');
    const [orderType, setOrderType] = useState({id:0})
    const [pronounceType, setPronounceType]  = useState({id:0})
    const [judgementType, setJudgementType]  = useState({id:0})

    const [orderTypes, setOrderTypes] =useState([]);
    const [pronounceTypes, setPronounceTypes] =useState([]);
    const [judgementTypes, setJudgementTypes] = useState([]);

    const [isDialog,setIsDialog] =useState(false);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState('');
 useEffect(() => {  

    onLoadPronounceType();
    onLoadOrderType();
    onLoadJudgementType();

   }, []);

    const onOrderTypeChange = (e) => {
        setOrderType({...orderType, [e.target.name]: e.target.value})   
    }
    const onPronunceTypeChange = (e) => {
        setPronounceType({...pronounceType, [e.target.name]: e.target.value})   
    }
    const onJudgementTypeChange = (e) => {
        setJudgementType({...judgementType, [e.target.name]: e.target.value})   
    }
    const onAdd=()=>{
        console.log(tab);
        console.log(isDialog);
        setIsDialog(true);
    }

   const onLoadPronounceType= async()=>{
           //for account registration
    try {
        setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/setup/judgement-setting/pronouce-types`, { 
            method: 'GET',
            headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            },
        });
        
        const data = await resp.json();
        setLoading(false);
        setPronounceTypes(data.list);
        
        } catch (error) {
        setLoading(false);
        console.error(error);
        }
    }
    const onLoadOrderType= async()=>{
           //for account registration
    try {
        setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/setup/judgement-setting/order-types`, { 
            method: 'GET',
            headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            },
        });
        
        const data = await resp.json();
        setLoading(false);
        setOrderTypes(data.list);
        
        } catch (error) {
        setLoading(false);
        console.error(error);
        }
    }
    const onLoadJudgementType= async()=>{
           //for account registration
    try {
        setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/setup/judgement-setting/judgement-types`, { 
            method: 'GET',
            headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            },
        });
        
        const data = await resp.json();
        setLoading(false);
        setJudgementTypes(data.list);
        
        } catch (error) {
        setLoading(false);
        console.error(error);
        }
    }
    
    const onEdit=(obj,index)=>{
        setErr('');
          setIsDialog(true);
        if(tab=='ordertype'){
            
            setOrderType(obj)
        } 
       else if(tab=='pronouncetype'){
          
            setPronounceType(obj)
        }
       else if(tab=='judgementtype'){
           
            setJudgementType(obj)
        }
        
     }

     const onSave=async(e)=>{
             e.preventDefault();
            var path='';
            var obj=null;
            if(tab=='ordertype' ){
                 path='/setup/judgement-setting/order-type';
                 obj={...orderType};
             }
              else if(tab=='pronouncetype'){
                 path='/setup/judgement-setting/pronounce-type';
                 obj={...pronounceType};
             }
              else if(tab=='judgementtype'){
                 path='/setup/judgement-setting/judgement-type';
                 obj={...judgementType};
             }
             
     
         setLoading(true)
                          try {
                            
                            const url=`${Constants.apiUrl}${path}`;
                            const resp = await fetch(url, {
                              method: 'POST',
                              body:JSON.stringify(obj) ,
                              headers: {
                                'Content-Type': 'application/json, text/plain',
                                Authorization: `Bearer ${token}`,
                              },
                            });
                            
                            const data = await resp.json();
                            setLoading(false);
                            if(data.code==0){
                             setAlert({open:true, title:'Setting',subtitle:'Settings saved successfully'})
                                 onDefault(data.id);
                            }
                            else if(data.code==-10){
                                  setIsExpired(true);
                              }else{
                                setErr(data.status);
                              }
                         //   setFlow({pos:6,code:"congrat"})
                            
                            
                          } catch (error) {
                            setLoading(false);
                            console.error(error);
                            
                           // onMove();
                          }
         }

const onDefault=(id)=>{
        setErr('');
          setIsDialog(false);
        if(tab=='ordertype'){
            onLoadOrderType();
            setOrderType({id:0})
        } 
       else if(tab=='pronouncetype'){
            onLoadPronounceType()
            setPronounceType({id:0})
        }
       else if(tab=='judgementtype'){
            onLoadJudgementType()
            setJudgementType({id:0})
        }
        
    }

    const onClose=()=>{
        setIsDialog(false);
        setOrderType({id:0})
        setPronounceType({id:0});
        setJudgementType({id:0});
        

    }
  return (
    <div>
     <div  className='tab_body'>
        <div className='tab_section' style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>  
          <JisTabButton code="ordertype" isActive={tab=='ordertype'}  title="Order Type" data={page} isRoleBased={false}  onClick={()=> setTab('ordertype')}/>
          <JisTabButton code="pronouncetype" isActive={tab=='pronouncetype'}  title="Pronouncement Type" isRoleBased={false}  data={page}  onClick={()=> setTab('pronouncetype')}/>
          <JisTabButton code="judgementtype" isActive={tab=='judgementtype'}  title="Judgement Type" data={page}  isRoleBased={false} onClick={()=> setTab('judgementtype')}/>  
        </div>
    {tab=='ordertype' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>Add Order Type</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Order Types</span><span className='total'>{orderTypes?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>Type</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                   { orderTypes.map((g, i) => { return (
                    <tr>
                       <td>{i+1}</td>
                       <td>{g.title}</td> 
                       <td>{g.eventType}</td>
                       <td><JisButton variant='plain' onClick={()=> onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}    
      {tab=='pronouncetype' &&  <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>Add Pronouncement Type</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Pronouncement Types</span><span className='total'>{pronounceTypes?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                      <th>SN</th>
                    <th>Title</th>
                    <th>Type</th>
                    <th>Action</th>  
                    </tr>
                </thead>
                <tbody>
                   { pronounceTypes.map((g, i) => { return (
                    <tr>
                      <td>{i+1}</td>
                       <td>{g.title}</td> 
                       <td>{g.type}</td>
                       <td><JisButton variant='plain' onClick={()=> onEdit(g,i)}>Edit</JisButton></td>  
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}  
     {tab=='judgementtype' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton onClick={onAdd}>Add Judgement Type</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Judgement Types</span><span className='total'>{judgementTypes?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                      <th>SN</th>
                    <th>Title</th>
                    
                    <th>Action</th>   
                    </tr>
                </thead>
                <tbody>
                   { judgementTypes.map((g, i) => { return (
                    <tr>
                     <td>{i+1}</td>
                     <td>{g.title}</td> 
                     <td><JisButton onClick={()=> onEdit(g,i)}>Edit</JisButton></td>     
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>}   
     </div>
     <BackLoader open={loading} />
   {isDialog && tab=='judgementtype' && <JisDialogForm title="Judgement Type" onClose={onClose}>
        <form  onSubmit={onSave}>
            <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Title'
                    name="title"
                    value={judgementType.title}
                    onChange={onJudgementTypeChange}
                    required={true}
                  />
                </div>
                </div>
        {/*  <div className="select-group">
                <label> Event Type <span className="required">*</span> </label>
                <select name="eventType" value={judgementType.eventType} required={true} onChange={onJudgementTypeChange} >
                    <option value="">Select </option>
                    <option value="All"> All Type</option>
                    <option value="CMC"> CMC</option>
                    <option value="Trial"> Trial</option>
                    <option value="Motion"> Motion</option>
                </select>
                </div>  */} 
          <JisCheckbox value={judgementType.isActive} label="Active" onChange={(e)=>setJudgementType({...judgementType,isActive:e})} />
                     <div><JisButton type='submit'>Save</JisButton></div> 
                     
        </form>
     </JisDialogForm>}  

   {isDialog && tab=='pronouncetype' && <JisDialogForm title="Pronouncement" onClose={onClose}>
        <form  onSubmit={onSave}>
            <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Title'
                    name="title"
                    value={pronounceType.title}
                    onChange={onPronunceTypeChange}
                    required={true}
                  />
                </div>
            </div>
             <div className="select-group">
                <label>  Type <span className="required">*</span> </label>
                <select name="type" value={pronounceType.type} required={true} onChange={onPronunceTypeChange} >
                    <option value="">Select </option>
                    <option value="All"> All Type</option>
                    <option value="Judgement"> Judgement</option>
                    <option value="Motion"> Motion</option>
                </select>
                </div> 
            <JisCheckbox value={pronounceType.isActive} label="Active" onChange={(e)=>setPronounceType({...pronounceType,isActive:e})} />
            <div><JisButton type='submit'>Save</JisButton></div>      
        </form>
     </JisDialogForm>}   

    {isDialog && tab=='ordertype' && <JisDialogForm title="Order Type"  onClose={onClose}>
        <form onSubmit={onSave}>
            <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Title'
                    name="title"
                    value={orderType.title}
                    onChange={onOrderTypeChange}
                    required={true}
                  />
                </div>
                </div>
         <div className="select-group">
                <label> Event Type <span className="required">*</span> </label>
                <select name="eventType" value={orderType.eventType} required={true} onChange={onOrderTypeChange} >
                    <option value="">Select </option>
                    <option value="All"> All Type</option>
                    <option value="CMC"> CMC</option>
                    <option value="Trial"> Trial</option>
                    <option value="Motion"> Motion</option>
                </select>
                </div>  
          <JisCheckbox value={judgementType.isActive} label="Active" onChange={(e)=>setJudgementType({...judgementType,isActive:e})} />
                     <div><JisButton type='submit'>Save</JisButton></div> 
                     
        </form>
     </JisDialogForm>}  

    </div>
  );
}

export default JudgementSettings;